import { useMemo } from 'react';
import { useEvaluationStore } from '../store';

export const useCompetencyData = (competencyId: string, reviewerId: string, revieweeId: string) => {
  const { responsesByComponentId, getSelectedScaleId } = useEvaluationStore();
  return useMemo(() => {
    const compId = String(competencyId);
    const entry = responsesByComponentId?.[compId];
    // Get comments and scale IDs directly from responses first
    const revieweeRaw = revieweeId ? entry?.answersByUserId?.[revieweeId] : undefined;
    const revieweeAnswerObj: any = revieweeRaw && typeof revieweeRaw === 'object'
      ? (revieweeRaw as any).answer || revieweeRaw
      : undefined;
    const revieweeComment: string = revieweeAnswerObj?.comment || '';
    // Get scale ID from answer first, then fallback to getSelectedScaleId
    const revieweeScaleIdFromAnswer = revieweeAnswerObj?.scale_id || revieweeAnswerObj?.scaleId;
    const revieweeSelectedScaleId = revieweeScaleIdFromAnswer
      ? String(revieweeScaleIdFromAnswer)
      : getSelectedScaleId('reviewee', competencyId);
    const reviewerRaw = reviewerId ? entry?.answersByUserId?.[reviewerId] : undefined;
    const reviewerAnswerObj: any = reviewerRaw && typeof reviewerRaw === 'object'
      ? (reviewerRaw as any).answer || reviewerRaw
      : undefined;
    const reviewerComment: string = reviewerAnswerObj?.comment || '';
    // Get scale ID from answer first, then fallback to getSelectedScaleId
    const reviewerScaleIdFromAnswer = reviewerAnswerObj?.scale_id || reviewerAnswerObj?.scaleId;
    const reviewerSelectedScaleId = reviewerScaleIdFromAnswer
      ? String(reviewerScaleIdFromAnswer)
      : getSelectedScaleId('reviewer', competencyId);
    return {
      revieweeSelectedScaleId,
      reviewerSelectedScaleId,
      revieweeComment,
      reviewerComment,
    };
  }, [responsesByComponentId, competencyId, reviewerId, revieweeId, getSelectedScaleId]);
};
